import {CustomerInfoComponent} from "./customer-info.component";

export default CustomerInfoComponent
